import { FeatureImportanceSummary } from "../types";
import { EChartsTransformer } from "./transformer";
import { formatAxisLabel, stripCodeSuffix } from "./utils/labelFormatter";

export const featureImpactTransformer: EChartsTransformer<FeatureImportanceSummary> = {
  transform: (fiSummary, wellData, chartContext) => {
    const isFullscreen = chartContext?.isFullscreen ?? false;

    if (!fiSummary) {
      return {};
    }
    const featureRank = fiSummary.feature_rank;
    // Sort data for better visualization (highest impact at the top)
    const sortedData = featureRank.features
      .map((feature, index) => ({
        feature: stripCodeSuffix(feature),
        value: featureRank.mean_shap_values[index]
      }))
      .sort((a, b) => a.value - b.value); // Sort ascending for horizontal bar

    return {
      animation: false,
      tooltip: {
        trigger: "axis",
        confine: true,
        extraCssText: "max-width: 320px; white-space: normal; word-break: break-word;",
        formatter: function (params) {
          const param = params[0];
          return `${param.marker}${param.name}: ${param.value.toFixed(4)}`;
        }
      },
      grid: {
        top: 10,
        bottom: 20,
        left: isFullscreen ? 9 : 2,
        right: 25,
        containLabel: true
      },
      xAxis: {
        type: "value",
        name: "Avg. Impact Magnitude",
        nameLocation: "middle",
        nameGap: 25,
        nameTextStyle: {
          fontSize: isFullscreen ? 13 : 12
        },
        axisLabel: {
          formatter: "{value}",
          fontSize: isFullscreen ? 13 : 12
        }
      },
      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0
        },
        {
          type: "inside",
          yAxisIndex: 0
        }
      ],
      yAxis: {
        type: "category",
        data: sortedData.map((item) => item.feature), // Use sorted features
        axisLabel: {
          interval: 0,
          fontSize: isFullscreen ? 12 : 10,
          width: isFullscreen ? 180 : 120,
          overflow: "truncate",
          lineHeight: isFullscreen ? 12 : 9.5,
          formatter: function (value) {
            return formatAxisLabel({
              value,
              dataLength: sortedData.length,
              isFullscreen
            });
          }
        }
      },
      series: [
        {
          name: "Feature Impact",
          type: "bar",
          data: sortedData.map((item) => item.value), // Use sorted values
          label: {
            show: false,
            position: "right",
            formatter: "{c}"
          }
        }
      ]
    };
  }
};
